import { parseOptionalNumericEnumFromApi } from '@/utils/core/data-transformation/enumHelpers';
import { CoreEnums } from '@/utils/domain/constants';

const NON_OPERATIONAL_ACTOR_STATUSES = new Set([
  CoreEnums.ChannelEntityStatus.PendingApproval,
  CoreEnums.ChannelEntityStatus.Rejected,
]);

const resolveActorStatus = (record) =>
  record?.status ?? record?.channelEntity?.status ?? record?.registrationStatus;

/** Pending approval or rejected: company exists but is not an operational channel actor. */
export const isPendingOrRejectedChannelActor = (record) => {
  if (!record) return false;
  const resolved = parseOptionalNumericEnumFromApi(
    CoreEnums.ChannelEntityStatus,
    resolveActorStatus(record),
  );
  return NON_OPERATIONAL_ACTOR_STATUSES.has(resolved);
};

/** Enabled badge: pending/rejected are never treated as an active record. */
export const isChannelActorEnabledForDisplay = (record) => {
  if (!record || isPendingOrRejectedChannelActor(record)) return false;
  return record.isActive === true;
};

/** canCreate* badges: pending/rejected cannot register children. */
export const isChannelActorCapabilityForDisplay = (record, field) => {
  if (!record || !field || isPendingOrRejectedChannelActor(record)) return false;
  return record[field] === true;
};
